import { render, staticRenderFns } from "./ContactNew.vue?vue&type=template&id=62b4877f&"
import script from "./ContactNew.vue?vue&type=script&lang=js&"
export * from "./ContactNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports